import { render, staticRenderFns } from "./RestartOverlay.vue?vue&type=template&id=3fbdf49c&"
import script from "./RestartOverlay.vue?vue&type=script&lang=js&"
export * from "./RestartOverlay.vue?vue&type=script&lang=js&"
import style0 from "./RestartOverlay.vue?vue&type=style&index=0&id=3fbdf49c&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../.yarn/__virtual__/vue-loader-virtual-783d792af9/0/cache/vue-loader-npm-15.10.0-778eb54c35-1bf6c9ffea.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports